<script lang="ts">
    import { afterNavigate } from '$app/navigation';
    import { GATEKEEPER_VERSION } from '$src/lib/services/gatekeeper/manage-gatekeeper.svelte';
    import { page } from '$app/state';
    import { getRoute } from '$src/lib/services/navigation';
    import ROUTE_IDS from '$src/generated/routeIds';

    afterNavigate(() => {
        if (!page.data.isLoggedIn) {
            return;
        }
        const TOUCH_URL = '/api/common/command/touch';
        fetch(TOUCH_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res): Promise<{ responseData: unknown }> => {
                if (!res.ok) return Promise.reject(new Error('Touch failed'));
                return res.json();
            })
            .then((response) => {
                // the bellow check is a copy over from FRS implementation.
                // Why it is needed is not clear, but the check is responseData not being undefined
                // essentially means session keeps rolling.
                // https://github.com/Casumo/frontend-react-stack/blob/master/src/components/SessionExpiredDetector/SessionExpiredDetector.tsx#L31
                if (response && !response.responseData) {
                    window.fabric
                        .getGatekeeper(GATEKEEPER_VERSION as 'v2.2.9', 'fabric-spine-v2')
                        .auth.logOut();
                }
            })
            .catch((err) => {
                console.error('Touch error', err);
                window.location.href = getRoute(ROUTE_IDS.HOME) ?? '/';
            });
    });
</script>
